const callsFindings = ({ calls = [], totalCalls = 0, callTasksToday = 0, actions = {} } = {}) => {
  const out = [];
  const list = Array.isArray(calls) ? calls : [];
  const noOutcome = list.filter(c => !c.disposition && !c.dispositionName);
  if (noOutcome.length) {
    out.push({
      tone: "warn",
      key: "no_outcome",
      label: `${noOutcome.length} calls without an outcome`,
      text: "Unlogged calls skew every report. Log them now.",
      actions: actions.logOutcomes ? [{ label: "Log outcomes", run: actions.logOutcomes }] : []
    });
  }
  const total = totalCalls || list.length;
  const connected = list.filter(c => c.connected || c.status === "CONNECTED").length;
  if (total >= 20 && connected / total < 0.15) {
    out.push({
      tone: "neutral",
      key: "low_connect",
      label: `Connect rate ${Math.round((connected / total) * 100)}%`,
      text: "Under 15%. Try a different time window or verify numbers before dialing.",
      actions: actions.ask ? [{ label: "When should I call?", run: () => actions.ask("When do my calls connect best? Use my call history.") }] : []
    });
  }
  const withOutcome = list.filter(c => c.disposition || c.dispositionName);
  const voicemail = withOutcome.filter(c => /voicemail|no answer|not answered/i.test(String(c.disposition || c.dispositionName)));
  if (withOutcome.length >= 10 && voicemail.length / withOutcome.length >= 0.6) {
    out.push({
      tone: "neutral",
      key: "voicemail_heavy",
      label: `${Math.round((voicemail.length / withOutcome.length) * 100)}% voicemail`,
      text: "Most calls hit voicemail. A 20-second script that earns a callback beats hanging up.",
      actions: actions.voicemailScript ? [{ label: "Write a script", run: actions.voicemailScript }] : []
    });
  }
  if (callTasksToday > 0) {
    out.push({
      tone: "hot",
      key: "call_tasks_today",
      label: `${callTasksToday} call tasks due today`,
      text: "Start dialing from the task list so outcomes log themselves.",
      actions: actions.startTasks ? [{ label: "Start tasks", run: actions.startTasks }] : []
    });
  }
  return out;
};

export default callsFindings;
